import { useEffect, useState } from "react";
import { deleteRow, getTests } from "./CommonFunc";
import { DataGrid, ruRU } from "@mui/x-data-grid";
import CrossIcon from "../Icons/Cross";
import EditRow from "./Dialogs/EditRow";
import Notifications from "../CommonComponents/Notifications/Notifications";

function AllTests() {
	const [rawList, setRawList] = useState([]);
	const [dateView, setDateView] = useState(true);
	const [viewDate, setViewDate] = useState(false);
	const [list, setList] = useState([]);
	const [ubnormal, setUbnormal] = useState(false);
	const [last, setLast] = useState(false);
	const [pattern, setPattern] = useState("");
	const [rowSelectionModel, setRowSelectionModel] = useState([]);
	const [editable, setEditable] = useState(false);
	const [info, setInfo] = useState(undefined);
	const [update, setUpdate] = useState(false);
	const [rowDeleted, setRowDeleted] = useState(false);
	useEffect(() => {
		if (viewDate) {
			getTests("TEST_NAME").then((res) => {
				setRawList(res);
			});
		} else {
			getTests().then((res) => {
				setRawList(res);
			});
		}
	}, [dateView, viewDate]);
	useEffect(() => {
		if (update || rowDeleted) {
			setUpdate(false);
			setRowDeleted(false);
			if (viewDate) {
				getTests("TEST_NAME").then((res) => {
					setRawList(res);
				});
			} else {
				getTests().then((res) => {
					setRawList(res);
				});
			}
		}
	}, [update, rowDeleted]);
	useEffect(() => {
		let filtredData = rawList.map((e, i) => ({ ...e, id: i }));
		if (ubnormal) {
			filtredData = filtredData.filter((item) => item.ARROW !== 0);
		}
		if (last) {
			filtredData = filtredData.reduce((accum, curr) => {
				let res = [...accum];
				if (
					accum.findIndex((item) => item.TEST_NAME === curr.TEST_NAME) === -1
				) {
					res.push(curr);
				}
				return res;
			}, []);
		}
		let resFormated = filtredData.map((item, i) => ({
			...item,
			ORDER_DATE_D: new Date(item.ORDER_DATE_D),
			ARROW: item.ARROW === 1 ? "↑" : item.ARROW === -1 ? "↓" : "•",
			UNITS: item.UNITS === "null" ? "" : item.UNITS,
		}));
		let resFiltred = resFormated.filter((item) => {
			return item.TEST_NAME.toLowerCase().includes(pattern.toLowerCase());
		});
		setList(resFiltred);
	}, [ubnormal, rawList, last, pattern]);
	const columns = [
		// { field: "CNT_ID", headerName: "ID", width: 100 },
		// { field: "ORDER_CODE", headerName: "Код заказа", width: 150 },
		{
			field: "ORDER_DATE_D",
			headerName: "Дата",
			width: 150,
			type: "date",
			// sortable: false
			// editable: editable,
		},
		{
			field: "TEST_NAME",
			headerName: "Вид анализа",
			width: 750,
			sortable: false,
			// editable: editable,
		},
		{
			field: "UNITS",
			headerName: "Ед.изм.",
			width: 120,
			sortable: false,
		},
		{
			field: "NUMERIC_ENTRY",
			headerName: "Знач.",
			width: 100,
			sortable: false,
			// type: "number",
			// editable: editable,
		},
		{
			field: "REFERENCE_LO",
			headerName: "Min",
			width: 115,
			sortable: false,
			// editable: editable,
		},
		{
			field: "REFERENCE_HI",
			headerName: "Max",
			width: 115,
			sortable: false,
			// editable: editable,
		},
		{
			field: "ARROW",
			headerName: "",
			width: 50,
			sortable: false,
			cellClassName: (params) => {
				return `health-app-theme--cell ${
					params.value === "↑" ? "high" : params.value === "↓" ? "low" : ""
				}`;
			},
		},
	];
	const handleDelete = () => {
		deleteRow(rawList[rowSelectionModel[0]].ID).then(() => {
			setRowDeleted(true);
		});
	};
	return (
		<div>
			<div className='sorting'>
				<div className='ubnormal-checkbox'>
					<input
						id='dateView'
						type='checkbox'
						checked={dateView}
						onChange={() => {
							setViewDate(false);
							setDateView(true);
						}}
					/>
					<label htmlFor='dateView'>дата-вид</label>
				</div>
				<div className='ubnormal-checkbox'>
					<input
						id='viewDate'
						type='checkbox'
						checked={viewDate}
						onChange={() => {
							setDateView(false);
							setViewDate(true);
						}}
					/>
					<label htmlFor='viewDate'>вид-дата</label>
				</div>
			</div>
			<div className='local-filtration'>
				<div className='ubnormal-checkbox'>
					<input
						id='norma'
						type='checkbox'
						checked={ubnormal}
						onChange={() => {
							// setLast(false);
							setUbnormal((prev) => !prev);
						}}
					/>
					<label htmlFor='norma'>только с отклонениями</label>
				</div>
				<div className='ubnormal-checkbox'>
					<input
						id='last'
						type='checkbox'
						checked={last}
						onChange={() => {
							// setUbnormal(false);
							setLast((prev) => !prev);
						}}
					/>
					<label htmlFor='last'>только последние</label>
				</div>
				<div className='ubnormal-checkbox'>
					{/* <label>Фильтр</label> */}
					<input
						id='last'
						type='text'
						value={pattern}
						placeholder='вид анализа'
						onChange={(e) => {
							setPattern(e.target.value);
						}}
					/>
					<CrossIcon
						width={2}
						height={2}
						className={"pattern-clear"}
						func={() => setPattern("")}
					/>
				</div>
			</div>
			<div className='local-filtration'>
				<div className='ubnormal-checkbox'>
					<button
						disabled={rowSelectionModel.length === 0}
						style={{ height: "1.5em", fontSize: "1em" }}
						onClick={() => {
							setEditable((prev) => !prev);
						}}
					>
						{`Корректировать выделенную стороку`}
					</button>
				</div>
				<div className='ubnormal-checkbox'>
					<button
						disabled={rowSelectionModel.length === 0}
						style={{ height: "1.5em", fontSize: "1em" }}
						onClick={handleDelete}
					>
						{`Удалить выделенную стороку`}
					</button>
				</div>
			</div>
			<div style={{ height: "calc(100% - 10em)", width: "100%" }}>
				<DataGrid
					rows={list}
					columns={columns}
					disableColumnMenu={true}
					localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
					onRowSelectionModelChange={(newRowSelectionModel) => {
						setRowSelectionModel(newRowSelectionModel);
						console.log(newRowSelectionModel);
					}}
					rowSelectionModel={rowSelectionModel}
					// editMode='row'
					onRowEditStop={(params, event) => {
						console.log(params);
						console.log(event);
					}}
					onRowEditCommit={(e) => {
						console.log("Commit", e);
					}}
				/>
			</div>
			{/* <Notifications info={info} setInfo={setInfo} /> */}
			{editable ? (
				<EditRow
					data={rawList[rowSelectionModel[0]] ?? {}}
					setEditable={setEditable}
					setUpdate={setUpdate}
					setInfo={setInfo}
				/>
			) : null}
		</div>
	);
}

export default AllTests;
